import {CURRENT_PRODUCT, Product} from 'constants'
import {connect} from '../redux/utils'
import {isBTYEnabled, isLTTEnabled, isPTOEnabled, isSDBEnabled, isURAEnabled} from '../features/selectors'
import ATAccessRightsChecker from './productAccessRightsChecker/ATAccessRightsChecker'
import APAccessRightsChecker from './productAccessRightsChecker/APAccessRightsChecker'

const ATAccessRightsCheckerConnected = connect(
    state => ({
        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isLTTEnabled: isLTTEnabled(state),
        isPTOEnabled: isPTOEnabled(state),
        isSDBEnabled: isSDBEnabled(state),
    })
)(ATAccessRightsChecker)

const APAccessRightsCheckerConnected = connect(
    state => ({

    })
)(APAccessRightsChecker)

let instance = null

export const getInstance = () => {
    if (!instance) {
        if(CURRENT_PRODUCT === Product.actiTIME) {
            instance = new ATAccessRightsCheckerConnected().init()
        } else {
            instance = new APAccessRightsCheckerConnected().init()
        }
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/js/util/AccessRightsChecker.js